module.exports = __webpack_public_path__ + "static/media/g-1-c.af2c79b5.jpg";